import { layoutReducer as layout } from './layout';
import { privacyNoticeReducer as privacyNotice } from './privacyNotice';
export { App } from './main';

export const reducers = { layout, privacyNotice };
